import React from 'react';

const Button = (props) => {
    const  {className='',  children=null, ...reset} = props;
    return (
        <button className={`btn ${className}`} {...reset}>{children}</button>
    );
};

export default Button;